import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "available-scripts"
    }}>{`Available Scripts:`}</h2>
    <p>{`You can run below commands in the root folder for your need.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"clean": "yarn workspaces run rimraf \\"{.next,node_modules,__generated__,.cache,src/graphql/*.d.ts,src/framework/graphql/**/*.d.ts}\\" && rimraf node_modules",
"gql-clean": "yarn workspaces run rimraf \\"{__generated__,src/graphql/*.d.ts,src/framework/graphql/**/*.d.ts}\\"",
"dev:admin-rest": "yarn workspace @marvel/admin-rest dev",
"build:admin-rest": "yarn workspace @marvel/admin-rest build",
"start:admin-rest": "yarn workspace @marvel/admin-rest start",
"dev:admin-gql": "yarn workspace @marvel/admin-graphql dev",
"build:admin-gql": "yarn workspace @marvel/admin-graphql build",
"start:admin-gql": "yarn workspace @marvel/admin-graphql start",
"prepare": "husky install"
`}</code></pre>
    <p><strong parentName="p">{` Note: `}</strong>{` Also, individual Scripts are available under every individual package.
You can check out them from there individual package.json file.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      